import { render, staticRenderFns } from "./scope-group.vue?vue&type=template&id=79bb494a&scoped=true&"
import script from "./scope-group.vue?vue&type=script&lang=ts&"
export * from "./scope-group.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79bb494a",
  null
  
)

export default component.exports